import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "../../assets/styles/login.css";

function LoginPage() {
  const { login } = useAuth();
  const [loginId, setLoginId] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!loginId.trim() || !pw.trim()) {
      setErr("Please enter Login ID/Email and Password.");
      return;
    }
    setLoading(true);
    setErr("");
    try {
      await login(loginId.trim(), pw.trim());
    } catch (error) {
      setErr(error.message || "Invalid email or password.");
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-left-glow" />
        <div className="login-left-dots" />
        <div className="login-left-content">
          <div className="login-logo-box">
            <img
              src="/logo.png"
              alt="Amshuhu"
              className="login-logo-img"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
            <div className="login-logo-fallback" style={{ display: "none" }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#1e3a5f" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </svg>
            </div>
          </div>
          <h1 className="login-brand">AMSHRMS</h1>
          <p className="login-brand-sub">Human Resource Management System</p>
          <p className="login-brand-co">Amshuhu iTech Solution Pvt. Ltd.</p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-wrap">
          <h2 className="login-title">Welcome to Amshuhu </h2>
          <p className="login-subtitle">
            Sign in with your company email or employee ID and password to access your dashboard.
          </p>

          {err && (
            <div className="login-error">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
              {err}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="login-field">
              <label className="login-label">LOGIN ID OR EMAIL</label>
              <div className="login-input-wrap">
                <svg
                  className="login-input-icon"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#94a3b8"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <input
                  type="text"
                  className="login-input"
                  placeholder="name@company.com or TMP-INT-1234"
                  value={loginId}
                  onChange={(e) => {
                    setLoginId(e.target.value);
                    setErr("");
                  }}
                  autoFocus
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="login-field">
              <label className="login-label">PASSWORD</label>
              <div className="login-input-wrap">
                <svg
                  className="login-input-icon"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#94a3b8"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                <input
                  type={showPw ? "text" : "password"}
                  className="login-input"
                  placeholder="Enter your password"
                  value={pw}
                  onChange={(e) => {
                    setPw(e.target.value);
                    setErr("");
                  }}
                  autoComplete="current-password"
                />
                <button type="button" className="login-pw-toggle" onClick={() => setShowPw(!showPw)} tabIndex={-1}>
                  {showPw ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? <span className="login-spinner" /> : <>Sign In <span style={{ marginLeft: 6 }}>-&gt;</span></>}
            </button>
          </form>

          <div className="login-footer">
            <span>Amshuhu iTech Solution Pvt. Ltd.</span>
            <span>AMSHRMS v1.0 | Human Resource Management System</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
